import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";

type StatTone = "default" | "primary" | "ok" | "issue" | "neutral";

const STAT_TONES: Record<StatTone, { bg: string; border: string; accent: string }> = {
  default: { bg: "smBackgroundSecondary", border: "smBorder", accent: "smMuted" },
  primary: { bg: "smPrimarySofter", border: "smPrimarySoft", accent: "smPrimary" },
  ok: { bg: "smStatusOkBg", border: "smStatusOkBorder", accent: "smStatusOkText" },
  issue: { bg: "smStatusIssueBg", border: "smStatusIssueBorder", accent: "smStatusIssueText" },
  neutral: { bg: "smStatusNeutralBg", border: "smStatusNeutralBorder", accent: "smStatusNeutralText" },
};

interface Props {
  icon: IconType;
  label: string;
  value: string;
  tone?: StatTone;
  mono?: boolean;
  pending?: boolean;
  onClick?: () => void;
}

export const HeaderStat = ({ icon, label, value, tone = "default", mono = false, pending = false, onClick }: Props) => {
  const colors = STAT_TONES[tone];
  const isInteractive = Boolean(onClick);
  return (
    <Box
      as={isInteractive ? "button" : undefined}
      type={isInteractive ? "button" : undefined}
      aria-label={isInteractive ? `${label}: ${value}` : undefined}
      onClick={onClick}
      bg={colors.bg}
      border="1px solid"
      borderColor={colors.border}
      rounded="lg"
      px="4"
      py="3"
      opacity={pending ? 0.55 : 1}
      w="full"
      textAlign="left"
      cursor={isInteractive ? "pointer" : "default"}
      transition="border-color 120ms ease, transform 120ms ease"
      _hover={isInteractive ? { borderColor: colors.accent, transform: "translateY(-1px)" } : undefined}
      _focusVisible={isInteractive ? { boxShadow: "smFocusRing" } : undefined}
    >
      <HStack spacing="2" mb="1.5">
        <Icon as={icon} boxSize="3.5" color={colors.accent} />
        <Text fontSize="xs" fontWeight="bold" letterSpacing="wider" textTransform="uppercase" color={colors.accent}>
          {label}
        </Text>
      </HStack>
      <Text fontSize="lg" fontWeight="bold" color="smText" noOfLines={1} fontFamily={mono ? "mono" : undefined}>
        {value}
      </Text>
    </Box>
  );
};
